import { type ContactType } from '@/app/models/Contact';
import { type JWTPayload } from '@/app/models/JWTPayload';

export function getUserTypeFromJWT(token: string): ContactType | undefined {
  try {
    const [, payload] = token.split('.');
    const decoded = JSON.parse(atob(payload)) as JWTPayload;
    return decoded.type as ContactType;
  } catch {
    return undefined;
  }
}
